<h2>Reporting</h2>

<div>
  <iframe width="1000" height="700" [src]="reportLink" frameborder="0" allowFullScreen="true"></iframe>
</div>